import React from "react";
import { motion } from "framer-motion";

/**
 * Reveal — fade + rise on scroll, powered by framer-motion.
 * Keeps the original API (`as`, `delay` in ms, `className`) so every
 * existing section upgrades to physics-based motion without changes.
 */
const EASE = [0.22, 1, 0.36, 1];

const Reveal = ({
  as = "div",
  delay = 0,
  y = 26,
  className = "",
  children,
  ...props
}) => {
  const MotionTag = motion[as] || motion.div;

  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay: delay / 1000, ease: EASE }}
      className={className}
      {...props}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
